import React, { forwardRef } from "react";
import "./OneClickSection.css";
import { motion } from "framer-motion";

const fadeUp = {
  initial: { opacity: 0, y: 18 },
  whileInView: { opacity: 1, y: 0 },
  transition: { duration: 0.65, ease: "easeOut" },
  viewport: { once: true, amount: 0.25 },
};

const steps = [
  {
    n: "01",
    title: "Choose your device",
    desc: "Printer or Wi‑Fi extender — start with the brand you already own.",
  },
  {
    n: "02",
    title: "Follow guided checks",
    desc: "We walk through power, connection, drivers, pairing, and signal in the right order.",
  },
  {
    n: "03",
    title: "Finish with a specialist",
    desc: "Stuck on an error? Call in and we’ll stay with you until the device is working.",
  },
];

const OneClickSection = forwardRef((_, ref) => (
  <section className="sssFlow" ref={ref} aria-label="How setup works">
    <div className="sssFlow__rail">
      {steps.map((s, i) => (
        <motion.article key={s.n} className="sssFlow__item" {...fadeUp} transition={{ delay: i * 0.08 }}>
          <span className="sssFlow__n">{s.n}</span>
          <h3>{s.title}</h3>
          <p>{s.desc}</p>
        </motion.article>
      ))}
    </div>
  </section>
));

export default OneClickSection;
